import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { MobileAppPtiRanking } from '../models/mobileAppPtiRanking';

@Component({
  template: ` <ng-container *ngIf="data[key] > 0.01; else lesspercent">
      <span>{{ data[key] | percent: format || '1.2' }}</span>
    </ng-container>
    <ng-template #lesspercent>< 1%</ng-template>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PercentDataComponent
  extends DataWidgetComponent
  implements OnInit
{
  @Input()
  data: MobileAppPtiRanking;

  ngOnInit(): void {
    super.ngOnInit();
  }
}
